import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDrivingRenewData = createAsyncThunk(
  "api/drivingLicense?renew=1",
  async (token) => {
    try {
      const response = await nodeinstance.get("/drivingLicense?renew=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const DrivingRenewDataSlice = createSlice({
  name: "Driving",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDrivingRenewData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getDrivingRenewData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDrivingRenewData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getDrivingRenewData };
export default DrivingRenewDataSlice.reducer;
